import { AppConst } from 'constants/appConst';
import { AppHelper } from 'helpers/appHelper';
import { useAppState } from 'hooks/useAppState';
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';

/**
 *　カンパニー選択画面
 */
export default function Signin(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();

  const [acctState] = useRecoilState(AcctState);

  const { initializeAcctState } = useAppState();

  const [processing, setProcessing] = useState(false);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    // カンパニー選択済みの場合はトップ画面へ遷移
    if (acctState.company) {
      navigate('/');
    }
  }, []);
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　カンパニー選択時の処理
   */
  const onCompanySelected = (companyId: string) =>
    AppHelper.submit(processing, setProcessing, async () => {
      try {
        await initializeAcctState(companyId);
        navigate('/');
      } catch (e) {
        showBoundary(e);
      }
    });

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-login">
        <div className="container">
          <div className="card card-login switch-companies">
            <div className="card-body">
              <h2 className="card-title text-start">カンパニーを切り替える</h2>
              <div className="button-group">
                {acctState.user?.companies.map(item => {
                  return (
                    <button
                      className="button-item d-flex justify-content-start align-items-center"
                      onClick={() => onCompanySelected(item.cd)}
                    >
                      <span className="img-body">
                        <img
                          src={AppHelper.getCompanyImageUrl(item.imageKey)}
                          className="icon icon-business img-fluid"
                          alt={item.name}
                        />
                      </span>
                      <span className="name">{item.name}</span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="text-center">
            <a href={AppConst.url.privacy} target="_blank" className="caption">
              privacy &amp; Terms
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
